import React from 'react'
import {connect} from 'react-redux'
import Tr from 'translations/Translations';
import Dialog from 'components/Dialog';
import GridBlock from 'components/GridBlock';
import Form from 'components/Form';
import * as Yup from 'yup';
import useId from 'hooks/useId';
import {makeStyles} from "@material-ui/core";
import DoubleButton from "components/popup/components/DoubleButton";
import VS from "constants/ValidationShema";
import PropTypes from 'prop-types'
import moment from "libs/moment";
import DateTimePicker from "components/DateTimePicker";
import DateFormats from "constants/DateFormats";

const useStyle = makeStyles(theme => ({
    margin: {
        marginBottom: theme.spacing(2)
    },
    disabledEmpty: {
        fontStyle: 'italic'
    },
    textField: {
        wordBreak: "break-word",
        whiteSpace: 'pre-line',
        marginBottom: theme.spacing(2)
    }
}));


function EnvelopeOfferDatePopup(
    {
        positions,
        onCancel,
        onSubmit,
        formSubmit,
    }) {

    const classes = useStyle();
    const formId = useId();
    const handleSubmit = () => formSubmit[formId]();

    return (
        <Dialog
            title={Tr('register_envelope')}
            open={true}
            maxWidth={'sm'}
            dialogActions={
                <DoubleButton
                    justify='flex-end'
                    labelFirst={Tr('cancel')}
                    labelSecond={Tr('confirm')}
                    onClickFirst={onCancel}
                    onClickSecond={handleSubmit}
                />}
        >

            <Form
                initialValues={{
                    envelopeOfferDate: moment(positions[0].offerDate),
                }}
                validationSchema={Yup.object().shape({
                    envelopeOfferDate: VS.lazy((offerDate) => {
                        if (!offerDate)
                            return VS.anyRequired();
                        const startMoment = moment(positions[0].startDate);
                        if (offerDate.isBefore(startMoment))
                            return VS.immediatelyError(Tr("v_data_cannot_be_before", {min: startMoment.format(DateFormats.DATETIME_FORMAT)}))
                        const endMoment = moment(positions[0].endDate);
                        if (offerDate.isAfter(endMoment))
                            return VS.immediatelyError(Tr("v_data_cannot_be_after", {max: endMoment.format(DateFormats.DATETIME_FORMAT)}))
                        return VS.any();
                    }),
                })}
                onSubmit={onSubmit}
                id={formId}
            >
                {(formikProps) => (
                    <GridBlock column>

                        <DateTimePicker
                            id="envelopeOfferDate"
                            formikProps={formikProps}
                            label={Tr("offer_date")}
                            className={classes.select}
                        />
                    </GridBlock>
                )}
            </Form>
        </Dialog>
    )
}

EnvelopeOfferDatePopup.propTypes = {
    positions: PropTypes.arrayOf(PropTypes.shape({
        identity: PropTypes.number.isRequired,
        endDate: PropTypes.string.isRequired,
        startDate: PropTypes.string.isRequired,
        offerDate: PropTypes.string.isRequired,
    })).isRequired,
    onCancel: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired
}

export default connect((state) => ({
    formSubmit: state.form
}), {})(EnvelopeOfferDatePopup);